import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ParseService } from '../parse/parse.service';
import { StorageConfiguration } from '../storage-setting/storage-configuration';

@Component({
  selector: 'app-add-leave',
  templateUrl: './add-leave.component.html',
  styleUrls: ['./add-leave.component.scss']
})
export class AddLeaveComponent implements OnInit {

  leaveForm: FormGroup;
  isEdit = false;
  oldDate: any;
  dateList = {
    "0": [],
    "1": [],
    "2": [],
    "3": [],
    "4": [],
    "5": [],
    "6": [],
    "7": [],
    "8": [],
    "9": [],
    "10": [],
    "11": []
  }
  currentDate = new Date();
  tenantId: any;

  constructor(
    private formBuilder: FormBuilder,
    private parseService: ParseService,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,

  ) {
    this.leaveForm = this.formBuilder.group({
      date: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    if (this.data.isEdit == true) {
      this.editLeave();
    }
  }

  async addLeave() {
    if (this.leaveForm.valid) {
      let leaveForm = this.leaveForm.value;
      let parsedDate = new Date(leaveForm.date);
      let leavedate = new Date(
        Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate())
      ).toISOString();
      let newData = {
        date: leavedate,
        holidayName: leaveForm.message
      }
      let year = new Date(leaveForm.date).getFullYear();
      const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
      const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
      holidayQuery.equalTo('year', year);
      holidayQuery.equalTo('tenantId', this.tenantId);
      const leaveResults = await holidayQuery.find();
      if (leaveResults.length > 0) {
        this.createHoliday(leaveResults, newData);
      }
      else {
        let holidayClass = this.parseService.instance.Object.extend('Holidays');
        var holidayDetails = new holidayClass();
        holidayDetails.set('year', year);
        holidayDetails.set('dateList', this.dateList);
        holidayDetails.set('holidayDetails', []);
        holidayDetails.set('tenantId', this.tenantId);
        holidayDetails.save().then(res => {
          let leaveResults = [];
          leaveResults.push(res);
          this.createHoliday(leaveResults, newData);
        });
      }
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  createHoliday(leaveResults, newData) {
    let data = leaveResults[0];
    let leaveDetails = data.get('holidayDetails');
    let index = leaveDetails.findIndex(x => x.date == newData.date);

    let dateList = data.get('dateList');
    let month = new Date(newData.date).getMonth();
    let date = new Date(newData.date).getDate();
    dateList[month].push(date);
    data.set('dateList', dateList);

    if (index == -1) {
      leaveDetails.push(newData);
      data.set('holidayDetails', leaveDetails);
      data.save();
      this.toastr.success('Saved successfully');
      this.dialog.closeAll();
    }
    else {
      this.toastr.warning('Holiday already assigned to this date');
    }
  }

  async editLeave() {
    this.oldDate = this.data.date;
    this.isEdit = this.data.isEdit;
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', new Date(this.oldDate).getFullYear());
    const leaveResults = await holidayQuery.find();
    let data = leaveResults[0];
    let leaveDetails = data.get('holidayDetails');
    let date = this.data.date;
    let value = leaveDetails.find(x => x.date == date);
    this.leaveForm.patchValue({
      date: new Date(value.date),
      message: value.holidayName
    });
  }

  async updateLeave() {
    if (this.leaveForm.valid) {
      let leaveForm = this.leaveForm.value;
      let parsedDate = new Date(leaveForm.date);
      let leavedate = new Date(
        Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate())
      ).toISOString();
      let newData = {
        date: leavedate,
        holidayName: leaveForm.message
      }
      let year = new Date(leaveForm.date).getFullYear();
      const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
      const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
      holidayQuery.equalTo('year', year);
      const leaveResults = await holidayQuery.find();
      if (leaveResults.length > 0) {
        let data = leaveResults[0];

        let dateList = data.get('dateList');
        // Removing old data
        let month = new Date(this.oldDate).getMonth();
        let date = new Date(this.oldDate).getDate();
        var foundIndex = dateList[month].findIndex(x => x == date);
        dateList[month].splice(foundIndex, 1);

        // Adding new data
        let newMonth = new Date(newData.date).getMonth();
        let newDate = new Date(newData.date).getDate();
        dateList[newMonth].push(newDate);
        data.set('dateList', dateList);

        let leaveDetails = data.get('holidayDetails');
        let index = leaveDetails.findIndex(x => x.date == this.oldDate);
        if (index != -1) {
          leaveDetails[index] = newData;
        }
        data.set('holidayDetails', leaveDetails);
        let res = await data.save();
        this.toastr.success('Saved successfully');
        this.dialog.closeAll();
      }
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  closepopup() {
    this.dialog.closeAll();
  }

}
